import { makeStyles } from 'tss-react/mui';

const name = 'TopBanners';

export const useTopBannersStyles = makeStyles({ name })(() => ({
  root: {
    position: 'fixed',
    top: 0,
    zIndex: 4,

    display: 'flex',
    flexDirection: 'column',

    width: '100%',
  },
}));
